export default "__VITE_ASSET__BNMZcqGN__";